module.exports = __webpack_public_path__ + "static/media/img-messaging.477eb5a6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img-messaging.svg
// module id = 1066
// module chunks = 0